import React from 'react';
import PropTypes from 'prop-types';
import fixImageUrl from '../../helpers/fixImageUrl';

const ItemDescription = props => (
  <div className="itemDescription" key={props.itemId}>
    <img className="productImage" src={fixImageUrl(props.mainImageUrl)} alt={props.productName} />
    <div className="info">
      <div className="from">
        <span className="label">From:</span>{' '}
        <span className="value">
          {props.containerName} - {props.itemName}
        </span>
      </div>
      <div className="product">
        <span className="label">Product:</span>{' '}
        <span className="value">
          {props.brand} {props.productName}
        </span>
      </div>
      <div className="color">
        <span className="label">Color:</span> <span className="value">{props.color}</span>
      </div>
    </div>
  </div>
);

ItemDescription.propTypes = {
  itemId: PropTypes.string.isRequired,
  containerName: PropTypes.string.isRequired,
  itemName: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  mainImageUrl: PropTypes.string.isRequired,
};

export default ItemDescription;
